import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const TrackingGoodsReciptApi = createApi({
  reducerPath: "TrackingGoodsReciptApi",
  baseQuery,
  tagTypes: ["TrackingGoodsRecipt"],

  endpoints: (builder) => ({

    // ✅ 173) CREATE GOODS RECEIPT
    createExportTracking: builder.mutation({
      query: ({ exportMasterId, goodsReceipt }) => ({
        url: `/export/mileStone/goods/${exportMasterId}`,
        method: "PUT",
        body: {
          goodsReceipt,
        },
        headers: {
          "X-Request-Id": "create-goods-receipt",
        },
      }),
      invalidatesTags: ["TrackingGoodsRecipt"],
    }),

    // ✅ 174) UPDATE GOODS RECEIPT
    updateExportTracking: builder.mutation({
      query: ({ exportMasterId, goodsReceiptId, goodsReceipt }) => ({
        url: `/export/mileStone/goods/${exportMasterId}/${goodsReceiptId}`,
        method: "PUT",
        body: {
          goodsReceipt,
        },
        headers: {
          "X-Request-Id": "update-goods-receipt",
        },
      }),
      invalidatesTags: ["TrackingGoodsRecipt"],
    }),

    // ✅ 175) DELETE GOODS RECEIPT
    deleteExportTracking: builder.mutation({
      query: ({ goodsReceiptId }) => ({
        url: `/export/mileStone/goods/${goodsReceiptId}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": "delete-goods-receipt",
        },
      }),
      invalidatesTags: ["TrackingGoodsRecipt"],
    }),

    // ✅ 176) GET GOODS RECEIPT BY MASTER + GOODS ID
    getGoodsReceiptById: builder.query({
      query: ({ exportMasterId, goodsReceiptId }) =>
        `/export/mileStone/goods/${exportMasterId}/${goodsReceiptId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["TrackingGoodsRecipt"],
    }),

    // ✅ 177) GET GOODS RECEIPT BY MASTER ID
    getGoodsReceiptByExportMasterId: builder.query({
      query: ({ exportMasterId }) =>
        `/export/mileStone/goods/${exportMasterId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["TrackingGoodsRecipt"],
    }),

  }),
});

export const {
  useCreateExportTrackingMutation,          // ✅ CREATE
  useUpdateExportTrackingMutation,          // ✅ UPDATE
  useDeleteExportTrackingMutation,          // ✅ DELETE
  useGetGoodsReceiptByIdQuery,              // ✅ GET BY MASTER + GOODS ID
  useLazyGetGoodsReceiptByExportMasterIdQuery, // ✅ GET BY MASTER ID
} = TrackingGoodsReciptApi;
